<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

    <b-form @submit="($event)=> $event.preventDefault() ">
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Solicitante"
          label-for="input-1"
      >
        <p>{{ $localStorageService.getNombreCompletoUsuario() }}</p>
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Clinica"
          label-for="input-1"
      >
        <v-select
            v-model="model.clinica"
            :options="clinicas"
            label="nombreClinica"
            @input="limpiarDatos"
            :reducer="(c)=> c.idClinica "
        ></v-select>

      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Paciente emisor"
          label-for="input-1"
      >
        <b-input-group>
          <b-form-checkbox v-model="buscarPorIdEmisor" >Buscar paciente por ID</b-form-checkbox>
        </b-input-group>
        <b-input-group>
          <b-form-input placeholder="Paciente (mínimo 10 caracteres y dos palabras)"
                        v-model="nombreEmisor"/>
          <b-input-group-append>
            <b-button v-on:click="traerPacientesPorNombreLikeEmisor">
              <b-spinner small variant="info" v-if="pacienteService.loading"/>
              <font-awesome-icon v-else icon="search"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <v-select
            v-if="pacientesEmisores.length > 0"
            v-model="model.pacienteOrigen"
            :options="pacientesEmisores"
            :reducer="(p)=> p.idPaciente"
            label="nombreCompleto"
            @input="traerBalance"
        ></v-select>
        <div v-if="saldoBloqueadoOrigen" style="font-weight: bold; color:red">
          El saldo del paciente Emisor se encuentra congelado
        </div>
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Paciente receptor"
          label-for="input-1"
      >
        <b-input-group>
          <b-form-checkbox v-model="buscarPorIdReceptor" >Buscar paciente por ID</b-form-checkbox>
        </b-input-group>
        <b-input-group>
          <b-form-input placeholder="Paciente (mínimo 10 caracteres y dos palabras)"
                        v-model="nombreReceptor"/>
          <b-input-group-append>
            <b-button v-on:click="traerPacientesPorNombreLikeReceptor">
              <b-spinner small variant="info" v-if="pacienteService.loading"/>
              <font-awesome-icon v-else icon="search"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <v-select
            v-if="pacientesReceptores.length > 0"
            v-model="model.pacienteDestino"
            :options="pacientesReceptores"
            :reducer="(p)=> p.idPaciente"
            @input="setPacienteDestino"
            label="nombreCompleto"
        ></v-select>
        <div v-if="saldoBloqueadoDestino" style="font-weight: bold; color:red">
          El saldo del paciente Receptor se encuentra congelado
        </div>
      </b-form-group>
      <b-form-group v-if="balance != null" class="text-left">
        <label class="text-left">Saldo actual del paciente emisor </label>
        <b-button variant="info" class="float-right" v-if="model.pacienteOrigen !== null"
                  v-on:click="traerBalance(model.pacienteOrigen)">
          <font-awesome-icon icon="sync"/>
        </b-button>
        <BalancePorTipoMovimiento v-if="balance!= null" :balance.sync="balance"/>
      </b-form-group>
      <b-form-group
          v-if="saldo != null && saldo >  0"
          id="input-group-1"
          label-align="left"
          label="Monto"
          label-for="input-1"
      >
        <b-form-input
            v-model="model.monto"
            type="text"
            @keypress="$onlyNumber"
            @keyup="$onlyNumber"
            @paste="$onlyNumber"        />

      </b-form-group>
      <p v-else-if="saldo != null && saldo <= 0 " class="alert alert-info">Saldo insuficiente</p>

      <BotonYListaSubirArchivos v-if="model.pacienteOrigen !== null && model.pacienteDestino !== null" padre="Traspaso" class="mb-2"
                                v-on:archivos="appendArchivo" :paciente="model.pacienteOrigen.idPaciente"></BotonYListaSubirArchivos>

      <b-button
          :disabled="canSend"
          class="mb-5 mt-5"
          type="submit"
          variant="primary"
          v-on:click="guardar"
          v-if="!saldoBloqueadoOrigen && !saldoBloqueadoDestino"
      >Guardar
      </b-button>

    </b-form>
  </div>
</template>

<script>
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import _ from "lodash";
import {TipoMovimientoService} from "../../../apiServices/tipoMovimiento/TipoMovimientoService";
import {MovimientoTraspasoCreateDto} from "../../../apiServices/dto/movimiento/MovimientoTraspasoCreateDto";
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";
import BalancePorTipoMovimiento from "../catalogos/TipoMovimiento/BalancePorTipoMovimiento";
import BotonYListaSubirArchivos from "../../../components/archivos/BotonYListaSubirArchivos";

export default {
  name: "FormTraspaso",
  components: {BotonYListaSubirArchivos, BalancePorTipoMovimiento},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    buscarPorIdEmisor: false,
    buscarPorIdReceptor: false,
    clinicas: [],
    archivos: [],
    nombreEmisor: '',
    nombreReceptor: '',
    pacientesReceptores: [],
    pacientesEmisores: [],
    balance: null,
    saldo: null,
    model: {
      pacienteOrigen: null,
      pacienteDestino: null,
      clinica: null,
      monto: null,
      empleado: null,
    },
    pacienteService: new PacienteService(),
    tipoMovimientoService: new TipoMovimientoService(),
    movimientoService: new MovimientoService(),
    tiposMovimiento: [],
    saldoBloqueadoOrigen: false,
    saldoBloqueadoDestino: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.model.empleado = this.$localStorageService.getIdEmpleado();
    this.clinicas = _.orderBy(this.$localStorageService.getClinicas(), ['nombreClinica'], ['asc']);
    this.$root.$on('refresh_tipo_movimiento', () => {
    });
  },
  computed: {
    isLoading() {
      return this.pacienteService.loading === true || this.tipoMovimientoService.loading === true || this.movimientoService.loading === true;
    },
    canSend() {
      return !(
          this.archivos.length > 0 &&
          this.model.monto > 0 &&
          this.model.pacienteDestino != null &&
          this.model.pacienteOrigen != null &&
          this.model.clinica != null &&
          this.model.empleado != null
      );
    }
  },
  methods: {
    guardar() {
      const traspasoDto = new MovimientoTraspasoCreateDto();
      traspasoDto.monto = this.model.monto;
      traspasoDto.idPacienteDestino = this.model.pacienteDestino.idPaciente
      traspasoDto.idPacienteOrigen = this.model.pacienteOrigen.idPaciente
      traspasoDto.idClinica = this.model.clinica.idClinica
      traspasoDto.idEmpleadoSolicito = this.model.empleado;
      traspasoDto.archivos = this.archivos.map(a => a.idArchivo);
      this.movimientoService.crearTraspaso(traspasoDto).then(() => {
        this.model = {
          pacienteOrigen: null,
          pacienteDestino: null,
          clinica: null,
          monto: null,
          empleado: null,

        };
        this.balance = null;
        this.archivos = [];
        this.model.empleado = this.$localStorageService.getIdEmpleado();
        this.$root.$emit('archivos', []);


      })
    },
    appendArchivo(archivos) {
      this.archivos = archivos;
    },
    calcularSaldo() {
      if (this.balance != null) {
        return this.balance.balanceKpi;
      } else {
        return 0;
      }
    },
    async forSelectTipoMovimiento() {
      this.tiposMovimiento = await this.tipoMovimientoService.forSelect(this.model.aFavor, this.model.generaRecibo)
    },
    async traerPacientesPorNombreLikeEmisor() {
      this.pacientesEmisores = [];
      if (this.buscarPorIdEmisor === false && this.nombreEmisor.length > 9 && this.nombreEmisor.split(' ').length >= 2) {
        this.pacientesEmisores = await this.pacienteService.obtenerPacientesPorNombreLike(this.nombreEmisor.toUpperCase());
      }else if (this.buscarPorIdEmisor === true){
        this.pacientesEmisores = await this.pacienteService.obtenerPacientesPorId(this.nombreEmisor.toUpperCase());
      }
    },
    async traerPacientesPorNombreLikeReceptor() {
      this.pacientesReceptores = [];
      if (this.buscarPorIdReceptor === false && this.nombreReceptor.length > 9 && this.nombreReceptor.split(' ').length >= 2) {
        this.pacientesReceptores = await this.pacienteService.obtenerPacientesPorNombreLike(this.nombreReceptor.toUpperCase());
      }else if (this.buscarPorIdReceptor === true){
        this.pacientesReceptores = await this.pacienteService.obtenerPacientesPorId(this.nombreReceptor.toUpperCase());
      }
    },
    async traerBalance(paciente) {
      this.$root.$emit('paciente', paciente);
      this.model.pacienteOrigen = paciente;
      await this.verificarBloqueo(paciente.idPaciente, true);
      this.movimientoService.obtenerBalance({idPaciente: paciente.idPaciente}).then((balance) => {
        this.balance = null;
        this.balance = balance;
        this.saldo = this.calcularSaldo();
      });
    },
    setPacienteDestino(paciente) {
      this.model.pacienteDestino = paciente;
      this.verificarBloqueo(paciente.idPaciente, false);
    },
    limpiarDatos() {
      this.pacienteService.data = [];
      this.model.pacienteOrigen = null;
      this.model.pacienteDestino = null;
      this.nombreReceptor = '';
      this.nombreEmisor = '';

    },
    verificarBloqueo(idPaciente, origen){

      if (origen) {
        this.saldoBloqueadoOrigen = false;
      } else {
        this.saldoBloqueadoDestino = false;
      }

      this.$http.post(this.$api + "ws/reembolsos/existeReembolsoProceso", {"idPaciente":idPaciente})
          .then((response) => {
            if (origen) {
              this.saldoBloqueadoOrigen = response.data.success;
            } else {
              this.saldoBloqueadoDestino = response.data.success;
            }
          });
    },
  },
  watch: {
    'model.monto'() {
      if (this.model.monto > this.saldo) {
        this.model.monto = this.saldo
      }
      if (this.model.monto <= 0) {
        this.model.monto = '';
      }
    }
  },
}
</script>

<style scoped>
.input-group > .v-select {
  width: 94% !important;
}
</style>
